import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderContainer from "../app/HeaderContainer";

const MaintenancePage = ({ messageDe, messageEn }) => {
  const intl = useIntl();
  const message = intl.locale === "en" ? messageEn : messageDe;

  return (
    <div className="maintenance">
      <HeaderContainer />
      <section className="maintenance-info">
        <article>
          <h1>
            <FormattedMessage id="maintenance.title" />
          </h1>
          <p>{message || intl.formatMessage({ id: "maintenance.text" })}</p>
        </article>
      </section>
    </div>
  );
};

MaintenancePage.propTypes = {
  messageDe: PropTypes.string,
  messageEn: PropTypes.string
};

export default MaintenancePage;
